// src/components/PageTransitionWrapper.js
import React from 'react';
import { motion } from 'framer-motion';

const variants = {
    initial: {
        opacity: 0,
        filter: 'blur(10px)', // Mulai dengan blur
        y: 20,                // Sedikit geser dari bawah
    },
    animate: {
        opacity: 1,
        filter: 'blur(0px)', // Hilangkan blur
        y: 0,
        transition: {
            duration: 0.6,
            ease: [0.25, 0.1, 0.25, 1],
        },
    },
    exit: {
        opacity: 0,
        filter: 'blur(10px)', // Blur saat keluar
        y: -20,
        transition: {
            duration: 0.4,
            ease: [0.4, 0, 0.2, 1],
        },
    },
};

const PageTransitionWrapper = ({ children }) => {
    return (
        <motion.div
            variants={variants}
            initial="initial"
            animate="animate"
            exit="exit"
            style={{ willChange: 'opacity, transform, filter' }} // optimasi GPU
        >
            {children}
        </motion.div>
    );
};

export default PageTransitionWrapper;
